import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  normalTaskID: '',
}

const normalTaskSlice = createSlice({
  name: 'normalTask',
  initialState,
  reducers: {
    setNormalTaskID: (state, action) => {
      state.normalTaskID = action.payload
    }
  }
})

export const { setNormalTaskID } = normalTaskSlice.actions

export default normalTaskSlice.reducer